import type { SVGProps } from 'react';
export const SvgLock = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M5 8.334V6.667c0-2.758.833-5 5-5s5 2.242 5 5v1.667"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M14.167 18.333H5.833c-3.333 0-4.166-.833-4.166-4.167V12.5c0-3.334.833-4.167 4.166-4.167h8.334c3.333 0 4.166.833 4.166 4.167v1.666c0 3.334-.833 4.167-4.166 4.167"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M13.33 13.334h.008M9.996 13.334h.008M6.662 13.334h.008"
		/>
	</svg>
);
